export enum Interactions {
  SubscriptionCancel = 'subscription_cancel',
}
